export enum EProductDetailPageEvents {
    LOADED_TAB_ALL_VARIANTS = 'pdp:all-variants:tab:loaded'
}
